const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export const isOlderThanFiveMinutes = (timestamp: number): boolean => {
    return Date.now() - timestamp > FIVE_MINUTES_IN_MS;
};
